import reduceColorPointByRatio from '../../../../common/utils/reduce-color-point-by-ratio';

const dark = (params) => {
  const { backgroundColor, infoColorPalette } = params;
  const fallback = {
    rule: 'input.colorBorder.focus.dark',
    params,
  };

  return reduceColorPointByRatio(
    {
      targetColor: infoColorPalette[900],
      targetColorPalette: infoColorPalette,
      backgroundColor,
      condition: (ratio) => ratio >= 3.7,
      fallback,
    },
    '900'
  );
};

export default dark;
